const w = (typeof window !== 'undefined' ? window : {}) as any;

export const environment = {
  PRODUCION: w.__env?.production ?? false,
  BASE_URL: w.__env?.BASE_URL ?? 'https://backendtest.capitaldivisas.com/api/v1',
  AUTH_URL: w.__env?.AUTH_URL ?? 'https://backendtest.capitaldivisas.com/api/v1/auth',
  googleClientId: w.__env?.googleClientId ?? '664009953610-7k9cs9jgjkvmle32sasda02rv2ln8q6k.apps.googleusercontent.com',
  appleClientId: w.__env?.appleClientId ?? 'com.capitaldivisas.web',
  googleMapsApiKey: w.__env?.googleMapsApiKey ?? '',
  googleMapsMapId: w.__env?.googleMapsMapId ?? '',
};

